const playerStates = {
  idle: 'idle',
  playing: 'playing',
  pause: 'pause',
  paused: 'pause',
  buffering: 'buffering',
  seeking: 'seeking'
};

export default playerStates;


// WEBPACK FOOTER //
// ./src/misc/player-states/index.js